export const baseUrl = process.env.REACT_APP_BASE_URL

export const last_week = 'Last Week';
export const last_month = 'Last Month';
export const last_year = 'Last Year';
export const last_8_hours = 'Last 8 hours';
export const last_16_hours = 'Last 16 hours';
export const last_24_hours = 'Last 24 hours';
